import React from 'react'
import Websocket from 'react-websocket'
import {Link, withRouter} from 'react-router-dom'
import {Media, Nav, Navbar} from 'reactstrap'
import AuthNavItem from './AuthNavItem'
import '../../stylesheets/Header.css'
import MarksmanLogo from '../../images/marksman-logo-small.png'
import StagingLogo from '../../images/marksman-logo-small-staging.png'

import {Team} from '../../models'
import {getTeam, WS_URL} from '../../api'

class Header extends React.Component {
    constructor(props) {
        super(props)

        const {className, history, loading, currentTeamID, user, token, toggleTeamSwitcherModal, path} = this.props
        this.toggleTeamSwitcherModal = toggleTeamSwitcherModal
        this.history = history
        let isLoggedIn = token && token.accessToken
        this.state = {className, user, token, loading, currentTeamID, teamName: "", isLoggedIn, path}

        this.fetchTeamName = this.fetchTeamName.bind(this)
        this.handleWebSocketResponse = this.handleWebSocketResponse.bind(this)
    }

    async componentDidMount() {
        let {token, currentTeamID} = this.state
        if (token) {
            this.setState({loading: true})
            let teamName = await this.fetchTeamName(currentTeamID, token)
            this.setState({teamName, loading: false, loggedIn: true})
        } else {
            this.setState({loggedIn: false})
        }
    }

    async componentWillReceiveProps(nextProps) {
        const {className, history, currentTeamID, user, token, toggleTeamSwitcherModal, path} = nextProps
        const oldTeamID = this.state.currentTeamID
        let teamName = this.state.teamName
        const oldToken = this.state.token

        if ((currentTeamID !== oldTeamID || token !== oldToken) && token) {
            teamName = await this.fetchTeamName(currentTeamID, token)
        }
        this.toggleTeamSwitcherModal = toggleTeamSwitcherModal
        this.history = history

        let isLoggedIn = token && token.accessToken
        await this.setState({className, user, token, currentTeamID, teamName, isLoggedIn, path})
    }

    async fetchTeamName(teamID, token) {
        let teamName = ""
        if (teamID && token) {
            try {
                let team = await getTeam(token, teamID, 'pico')
                teamName = team.name
            } catch (error) {
                console.log(error)
            }
        }
        return teamName
    }

    handleWebSocketResponse(data) {
        let {currentTeamID} = this.state
        let result = JSON.parse(data)
        let team = Team.fromAPIObject(result)

        if (parseInt(team.id) === parseInt(currentTeamID)) {
            this.setState({teamName: team.name})
        }
    }

    render() {
        let {className, loading, teamName, currentTeamID, path, isLoggedIn, user, token} = this.state

        return <Navbar color="faded" light expand="md"
                       className={`header bg-muted-sf-orange border-bottom sticky-top ${className}`}>
            <Link to={isLoggedIn ? "/controllers" : "/"} className="navbar-brand">
                <Media object src={window.location.href.includes("staging") ? StagingLogo : MarksmanLogo} alt="Marksman Logo"/>
            </Link>
            <Nav className="ml-auto" navbar>
                <AuthNavItem history={this.history}
                             user={user}
                             teamName={teamName}
                             loading={loading || path === "/login" || (!user && path === "/")}
                             toggleTeamSwitcherModal={this.toggleTeamSwitcherModal}/>
            </Nav>
            {isLoggedIn && currentTeamID && token ?
                <Websocket url={`${WS_URL}/teams/${currentTeamID}/?access_token=${token.accessToken}`}
                           onMessage={this.handleWebSocketResponse}/> : null}
        </Navbar>
    }
}

export default withRouter(Header)


// WEBPACK FOOTER //
// ./src/components/ui/Header.js